module.exports = __webpack_public_path__ + "fonts/fa-brands-400.2563b3e.eot";